<template>
  <div id="search" :style="{backgroundImage: imgBg}">
    <div class="page-box" >
      <com-header ref="header"/>
      <div class="page-box-search-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
        <div class="search-input-box">
          <div class="search-input">
            <img src="../../static/image/header-search.png" alt="">
            <el-input v-model="request.keyword" placeholder="请输入搜索内容" clearable @change="searchInput" @keyup.enter.native="searchButtonFun"></el-input>
          </div>
          <div class="search-button" @click="searchButtonFun()">搜索</div>
        </div>
        <div class="search-content">
          <div class="search-value-list" v-if="request.keyword === '' && imgList.length == 0 && loadNum === 0">
            <div class="search-value-item" v-for="item in searchDefault" @click="defaultValue(item.keyword)">
              {{item.keyword}}
            </div>
          </div>
          <div class="search-no-data" v-if="imgList.length === 0 && loadNum != 0">
            <img src="../../static/image/no-data.png" alt="">
            <p>无搜索结果，换个词试试吧~</p>
          </div>
          <com-card :imgList="imgList" :total="request.total" v-if="imgList.length > 0" @collectCall="collectCall"/>
      </div>

    </div>
    </div>
    <el-backtop target=".page-box-search-scroll"></el-backtop>
  </div>
</template>

<script>
export default {
  name: "search",
  data(){
    return {
      navDrawer: false,
      request: {
        keyword: '',
        size: 9,
        page: 1,
        total: 0,
      },
      searchDefault: [],
      imgList: [],
      loadNum: 0,
      loading:true,
      navList:[],
      imgBg:''
    }
  },
  mounted() {
    this.getSearchDefault()
    this.navList = JSON.parse(localStorage.getItem('navList'))
  },

  methods: {

    load(){
      if(this.request.total > this.imgList.length && this.loading){
        this.loading = false
        this.request.page = this.request.page +1
        this.getSearchList()
      }
    },
    getHandleImg(data,img) {
      if (data.length > 0) {
        let arr = []
        data.forEach((item) => {
          if(item.id !== img.id){
            arr.push( item.url)
          }
        })
        arr.unshift(img.url)
        return arr
      }
      return []
    },
    collectCall(data) {
      this.$refs.header.getCollect()
      this.imgList.forEach((item) => {
        if (item.id === data.id) {
          if (item.iscollect === 0) {
            item.iscollect = 1
            item.collection = Number(item.collection) + 1
          } else {
            item.iscollect = 0
            item.collection = Number(item.collection) - 1
          }
        }
      })
    },
    searchInput(value) {
      this.searchDefault = value
    },
    navDrawerFun() {
      this.navDrawer = !this.navDrawer
    },
    getSearchDefault() {
      this.$get('/pc/shop/hotSearch', {}).then((res) => {
        this.searchDefault = res.data
      }).catch((error) => {
        this.$message.error(error.message);
      })
    },
    defaultValue(value) {
      this.request.keyword = value
      this.searchButtonFun()
    },
    searchButtonFun() {
      this.request = {
        ...this.request,
        size: 9,
        page: 1,
        total: 0,
      }
      this.loadNum = 0
      this.imgList = []
      this.getSearchList()
    },
    getSearchList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
     this.$get('/pc/shop/searchKeyword', this.request).then((res) => {
        loading.close();
        this.loading = true
        this.imgList = [...this.imgList,...res.data]
        this.request.total = res.meta.total
        this.loadNum = this.loadNum + 1
      }).catch((error) => {
        this.loading = true
        this.loadNum = this.loadNum + 1
        loading.close();
      })
    },
    clickLog(list, img) {
      this.$get('/pc/shop/clickLog', {packageid: list.id, imageid: img.id}).then((res) => {
      })
    }
  }
}
</script>

<style scoped lang="less">
#search{
  width: 100vw;
  height: 100vh;
}

.search-content{
  margin-right: 30px;
}

.search-content-empty{
  width: 900px;
  margin: 240px auto;
}

.search-input-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 900px;
  height: 74px;
  background: #333333;
  border-radius: 8px;
  margin: 37px auto 0;
}
.search-input{
  display: flex;
  align-items: center;
  flex:1;
  margin-left: 20px;
}
.search-input img{
  width: 34px;
  height: 34px;
}
.search-input .el-input{
  margin-left: 20px;
  border:none;
}
.search-input .el-input input{
  border:none;
  background: transparent;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #BFBFBF;
}
.search-button{
  width: 120px;
  height: 74px;
  line-height: 74px;
  background: #E8B45E;
  border-radius: 0px 8px 8px 0px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  text-align:center;
}
.search-value-list{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 900px;
  margin: 73px auto;
}

.search-value-item{
  padding:0  20px;
  height: 58px;
  margin: 0 30px 30px 0;
  line-height: 58px;
  border: 1px solid #BFBFBF;
  border-radius: 4px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  text-align:center;
}

.search-no-data{
  position:relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 660px;
  height: 485px;
  margin: 85px auto 0;
}
.search-no-data img{
  width: 100%;
  height: 100%;
}
.search-no-data p {
  position:absolute;
  top:420px;
  left:0;
  right:0;
  margin: 0 auto;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
  text-align:center;
}

.search-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
  margin-left: -30px;
}
.search-list-item{
  width: 540px;
  height: 620px;
  background: #FFFFFF;
  border-radius: 6px;
  margin-right: 30px;
  margin-bottom: 30px;
}
.search-list-item:hover{
  transform: scale(1.05);
  transition: all 0.3s;
}
.item-img{
  box-sizing: border-box;
  height: 538px;
  padding: 20px;
  border-bottom: 2px solid  #ECECEC;
}
.el-image{
  width: 153px;
  height: 153px;
  border-radius: 4px;
  margin-right:19px;
  margin-bottom: 20px;
}
.item-img .el-image:nth-child(3n){
  margin-right: 0;
}
.search-item-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 20px;
}
.search-title{
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  line-height: 39px;
}
.search-footer-collect{
  position:relative;
  display: flex;

}
.search-footer-collect img{
  width: 67px;
  height: 42px;
  margin-right: 20px;
}
.collect-number{
  position:absolute;
  top:0;
  right:0;
  width: 40px;
  height: 18px;
  line-height: 18px;
  background: #FF1717;
  border-radius: 9px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #FFFFFF;
  text-align:center;
}
.search-pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/search.vue